module.exports = __webpack_public_path__ + "img/answer-failed.b979f51b.png";